// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from 'F:/projects/webstorm_project/web/business/api-admin-frontend/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import TableOutlined from 'F:/projects/webstorm_project/web/business/api-admin-frontend/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/TableOutlined';
export default { SmileOutlined, TableOutlined };
